export default __webpack_public_path__ + "static/media/tibet.d244b184.svg";